/** Conference tabs from nav-prototype — filter standings only. */
export interface BroadcastConference {
  id: string;
  label: string;
  power: boolean;
  /** Substrings matched against Team.conference (case-insensitive). */
  match: string[];
}

export const BROADCAST_CONFERENCES: BroadcastConference[] = [
  { id: 'all', label: 'All D1', power: true, match: [] },
  { id: 'acc', label: 'ACC', power: true, match: ['acc'] },
  { id: 'big12', label: 'Big 12', power: true, match: ['big 12', 'big12', 'big xii'] },
  { id: 'bigeast', label: 'Big East', power: true, match: ['big east'] },
  { id: 'big10', label: 'Big Ten', power: true, match: ['big ten', 'big 10', 'bigten'] },
  { id: 'sec', label: 'SEC', power: true, match: ['sec'] },
  { id: 'pac12', label: 'Pac-12', power: false, match: ['pac-12', 'pac 12', 'pac12'] },
  { id: 'aac', label: 'American', power: false, match: ['american', 'aac'] },
  { id: 'a10', label: 'A-10', power: false, match: ['atlantic 10', 'a-10', 'a10'] },
  { id: 'mwc', label: 'Mountain West', power: false, match: ['mountain west', 'mwc'] },
  { id: 'wcc', label: 'WCC', power: false, match: ['west coast', 'wcc'] },
  { id: 'mvc', label: 'Missouri Valley', power: false, match: ['missouri valley', 'mvc'] },
  { id: 'cusa', label: 'C-USA', power: false, match: ['conference usa', 'c-usa', 'cusa'] },
  { id: 'sunbelt', label: 'Sun Belt', power: false, match: ['sun belt'] },
  { id: 'mac', label: 'MAC', power: false, match: ['mid-american', 'mac'] },
  { id: 'bigwest', label: 'Big West', power: false, match: ['big west'] },
  { id: 'caa', label: 'CAA', power: false, match: ['colonial', 'caa'] },
  { id: 'horizon', label: 'Horizon', power: false, match: ['horizon'] },
  { id: 'ivy', label: 'Ivy League', power: false, match: ['ivy'] },
  { id: 'metro', label: 'Metro', power: false, match: ['metro'] },
  { id: 'socon', label: 'SoCon', power: false, match: ['southern', 'socon'] },
  { id: 'bigsky', label: 'Big Sky', power: false, match: ['big sky'] },
  { id: 'summit', label: 'Summit', power: false, match: ['summit'] },
  { id: 'asun', label: 'ASUN', power: false, match: ['asun', 'atlantic sun'] },
  { id: 'ae', label: 'America East', power: false, match: ['america east', 'am. east', 'ameast'] },
  { id: 'bigsouth', label: 'Big South', power: false, match: ['big south'] },
  { id: 'meac', label: 'MEAC', power: false, match: ['meac'] },
  { id: 'nec', label: 'NEC', power: false, match: ['northeast', 'nec'] },
  { id: 'ovc', label: 'OVC', power: false, match: ['ohio valley', 'ovc'] },
  { id: 'patriot', label: 'Patriot', power: false, match: ['patriot'] },
  { id: 'southland', label: 'Southland', power: false, match: ['southland'] },
  { id: 'swac', label: 'SWAC', power: false, match: ['swac'] },
  { id: 'uac', label: 'UAC', power: false, match: ['united athletic', 'uac'] },
  { id: 'indy', label: 'Independents', power: false, match: ['independents', 'independent'] },
];

/** Match ESPN short names (exact) plus longer aliases. Avoids AAC⊂"mid-american". */
export function conferenceMatches(confId: string, teamConference: string | null | undefined): boolean {
  if (confId === 'all') return true;
  const conf = BROADCAST_CONFERENCES.find((c) => c.id === confId);
  if (!conf) return false;
  const raw = (teamConference || '').toLowerCase().trim();
  if (!raw) return false;
  for (const m of conf.match) {
    if (raw === m) return true;
  }
  for (const m of conf.match) {
    if (m.length >= 5 && raw.includes(m)) return true;
  }
  return false;
}
